import React, { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import http from '../../../http';
import Swal from 'sweetalert2';
import MaterialTable from 'material-table';
import '../../../imageUrl';

function MrpChannel() {
  const [row_data_list, setRowDataList] = useState([]);

  useEffect(() => {
    http.get('mrp-master-channels').then((res) => {
      if (res.data?.status === 200 && Array.isArray(res.data.data)) {
        setRowDataList(res.data.data);
      }
    });
  }, []);

  const deleteRowData = (e, id) => {
    e.preventDefault();
    const thisClicked = e.currentTarget;

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        http.delete(`mrp-master-channels/${id}`).then((res) => {
          if (res.data?.status === 200) {
            setRowDataList((prev) => prev.filter((row) => row.id !== id));
          }
        });
        Swal.fire({
          position: 'top-center',
          icon: 'success',
          title: 'Deleted!',
          text: 'Your data has been deleted.',
          timer: 2500,
        });
      }
    });
  };

  const columns = [
    {
      title: 'SL',
      field: '',
      render: (row) => <div>{row.tableData.id + 1}</div>,
      width: '20 !important',
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      title: 'Channel Name',
      field: 'channel_name',
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      title: 'Action',
      field: 'patient',
      render: (row) => (
        <div>
          <Link to={`/edit-mrp-channel/${row.id}`} className="btn btn-sm action-btn">
            <i className="far fa-edit"></i>
          </Link>
          &nbsp;
          <button onClick={(e) => deleteRowData(e, row.id)} className="btn btn-sm action-btn">
            <i className="far fa-trash"></i>
          </button>
        </div>
      ),
      cellStyle: {
        textAlign: 'center',
      },
    },
  ];

  return (
    <div className="page-content">
      <div className="custom-card patients-head ">
        <h5 className="fw-normal custom_py-3 px-2 text-start mb-2 card-title">
          Sales Channel List
          <Link className="btn btn-sm btn-primary float-end" to="/add-mrp-channel">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus mb-1">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Sales Channel
          </Link>
        </h5>
      </div>
      <div className="row">
        <div className="col-md-12 grid-margin">
          <div>
            <MaterialTable
              columns={columns}
              data={row_data_list}
              options={{
                search: true,
                showTitle: false,
                searchFieldAlignment: 'left',
                pageSize: 10,
                emptyRowsWhenPaging: false,
                pageSizeOptions: [5, 10, 20, 50, 100],
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MrpChannel;
